// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__LCmpx","form__button":"styles_form__button__ThzZj","form__preOrderLink":"styles_form__preOrderLink__y_NBz"};